import React from 'react';
import PropTypes from 'prop-types';

import useBreakpoints from 'hooks/useBreakpoints';
import {getBreakpointValue} from 'utils/ui';

import Carousel from './Carousel';

function ResponsiveCarousel({
	breakpoints,
	gutterWidth,
	lookAhead,
	itemsPerSlide,
	maxItems,
	...otherProps
}) {
	const {currentBreakpoint} = useBreakpoints(breakpoints);

	return (
		<Carousel
			gutterWidth={getBreakpointValue(
				gutterWidth,
				breakpoints,
				currentBreakpoint
			)}
			lookAhead={getBreakpointValue(
				lookAhead,
				breakpoints,
				currentBreakpoint
			)}
			itemsPerSlide={getBreakpointValue(
				itemsPerSlide,
				breakpoints,
				currentBreakpoint
			)}
			maxItems={getBreakpointValue(
				maxItems,
				breakpoints,
				currentBreakpoint
			)}
			{...otherProps}
		/>
	);
}

ResponsiveCarousel.propTypes = {
	breakpoints: PropTypes.array.isRequired,
	itemsPerSlide: PropTypes.oneOfType([
		PropTypes.number,
		PropTypes.arrayOf(PropTypes.number.isRequired),
	]).isRequired,
	gutterWidth: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.arrayOf(PropTypes.string.isRequired),
	]).isRequired,
	maxItems: PropTypes.oneOfType([
		PropTypes.number,
		PropTypes.arrayOf(PropTypes.number.isRequired),
	]),
	lookAhead: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.arrayOf(PropTypes.string),
	]),
};

export default ResponsiveCarousel;
